import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Pages publiques
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import HowItWorks from './pages/HowItWorks';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Register from './pages/Register';
import AccountDashboard from './pages/account/Dashboard';
import AccountOrders from './pages/account/Orders';

// Pages légales
import CGV from './pages/legal/CGV';
import Returns from './pages/legal/Returns';
import Privacy from './pages/legal/Privacy';
import Cookies from './pages/legal/Cookies';
import Mentions from './pages/legal/Mentions';

// Layout Admin
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/Dashboard';
import AdminOrders from './pages/admin/Orders';
import AdminProducts from './pages/admin/Products';
import AdminUsers from './pages/admin/Users';
import AdminDelivery from './pages/admin/Delivery';
import Payments from './pages/admin/Payments';

import './index.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <CartProvider>
          <Routes>
            {/* Routes publiques AVEC Navbar et Footer */}
            <Route path="/" element={
              <div className="min-h-screen flex flex-col bg-cream">
                <Navbar />
                <main className="flex-grow">
                  <Home />
                </main>
                <Footer />
              </div>
            } />
            <Route path="/products" element={
              <div className="min-h-screen flex flex-col bg-cream">
                <Navbar />
                <main className="flex-grow">
                  <Products />
                </main>
                <Footer />
              </div>
            } />
            <Route path="/products/:id" element={
              <div className="min-h-screen flex flex-col bg-cream">
                <Navbar />
                <main className="flex-grow">
                  <ProductDetail />
                </main>
                <Footer />
              </div>
            } />
            <Route path="/cart" element={
              <div className="min-h-screen flex flex-col bg-cream">
                <Navbar />
                <main className="flex-grow">
                  <Cart />
                </main>
                <Footer />
              </div>
            } />
            <Route path="/checkout" element={
              <div className="min-h-screen flex flex-col bg-cream">
                <Navbar />
                <main className="flex-grow">
                  <Checkout />
                </main>
                <Footer />
              </div>
            } />
            <Route path="/how-it-works" element={
              <div className="min-h-screen flex flex-col bg-cream">
                <Navbar />
                <main className="flex-grow">
                  <HowItWorks />
                </main>
                <Footer />
              </div>
            } />
            <Route path="/faq" element={
              <div className="min-h-screen flex flex-col bg-cream">
                <Navbar />
                <main className="flex-grow">
                  <FAQ />
                </main>
                <Footer />
              </div>
            } />
            <Route path="/contact" element={
              <div className="min-h-screen flex flex-col bg-cream">
                <Navbar />
                <main className="flex-grow">
                  <Contact />
                </main>
                <Footer />
              </div>
            } />
            <Route path="/login" element={
              <div className="min-h-screen flex flex-col bg-cream">
                <Navbar />
                <main className="flex-grow">
                  <Login />
                </main>
                <Footer />
              </div>
            } />
            <Route path="/register" element={
              <div className="min-h-screen flex flex-col bg-cream">
                <Navbar />
                <main className="flex-grow">
                  <Register />
                </main>
                <Footer />
              </div>
            } />

            {/* Pages légales AVEC Navbar et Footer */}
            <Route path="/legal/cgv" element={
              <div className="min-h-screen flex flex-col bg-cream">
                <Navbar />
                <main className="flex-grow">
                  <CGV />
                </main>
                <Footer />
              </div>
            } />
            <Route path="/legal/returns" element={
              <div className="min-h-screen flex flex-col bg-cream">
                <Navbar />
                <main className="flex-grow">
                  <Returns />
                </main>
                <Footer />
              </div>
            } />
            <Route path="/legal/privacy" element={
              <div className="min-h-screen flex flex-col bg-cream">
                <Navbar />
                <main className="flex-grow">
                  <Privacy />
                </main>
                <Footer />
              </div>
            } />
            <Route path="/legal/cookies" element={
              <div className="min-h-screen flex flex-col bg-cream">
                <Navbar />
                <main className="flex-grow">
                  <Cookies />
                </main>
                <Footer />
              </div>
            } />
            <Route path="/legal/mentions" element={
              <div className="min-h-screen flex flex-col bg-cream">
                <Navbar />
                <main className="flex-grow">
                  <Mentions />
                </main>
                <Footer />
              </div>
            } />

            {/* Espace client */}
            <Route path="/account" element={<AccountDashboard />} />
            <Route path="/account/orders" element={<AccountOrders />} />

            {/* Routes admin SANS Navbar et SANS Footer */}
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="orders" element={<AdminOrders />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="delivery" element={<AdminDelivery />} />
              <Route path="payments" element={<Payments />} />
            </Route>
          </Routes>
          <Toaster position="top-right" />
        </CartProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;